// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.bharatbox",
    name: "BharatBox App",
    homepage: "https://bharatbox.io/",
    image_id: "8bef836e-9d6a-4318-ebda-930c39246300",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/bharatbox/id6472478382",
        android: null,
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "bharatbox://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map